class UAIntersection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.actions = this.getAttribute('data-actions').split(',');

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    });

    this.observer.observe(this);
  }

  handleIntersection(entries) {
    if (entries[0].isIntersecting) {
      this.handleStickyPCPFilters(true);
    } else {
      this.handleStickyPCPFilters(false);
    }
  }

  handleStickyPCPFilters(hide) {
    if (!this.actions.includes('sticky-pcp-filters')) return;
    const isMobile = window.innerWidth < 768;
    const htmlEl = document.documentElement;

    const stickyPCPFilters = document.querySelector('.product-grid-top-bar');
    if (!stickyPCPFilters) return;

    if (!isMobile) {
      htmlEl.classList.remove('hide--sticky-pcp-filters');
      return;
    }

    if (hide) {
      htmlEl.classList.add('hide--sticky-pcp-filters')
    } else {
      htmlEl.classList.remove('hide--sticky-pcp-filters')
    }
  }
}

customElements.define("ua-intersection", UAIntersection);
